import type { ReactNode } from 'react';
import { Info } from 'lucide-react';

/** One gray line with an info icon, used when an action is not available. */
export function InfoMessage({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-start gap-3 px-5 py-4 text-sm text-gray-600">
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-gray-400" />
      <p>{children}</p>
    </div>
  );
}
